interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}

export default function SectionHeading({
  kicker,
  title,
  description,
  align = 'left',
  tone = 'light',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`flex flex-col ${isCenter ? 'items-center text-center' : 'items-start'}`}>
      {kicker && (
        <span
          className={`mb-3 inline-flex items-center gap-2 rounded-full px-3 py-1 font-label text-xs tracking-wide ${
            tone === 'dark'
              ? 'bg-background-50/10 text-background-100'
              : 'bg-primary-100 text-primary-700'
          }`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-current" />
          {kicker}
        </span>
      )}
      <h2
        className={`font-heading text-3xl md:text-4xl font-bold leading-tight ${
          tone === 'dark' ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-4 max-w-2xl text-sm md:text-base leading-relaxed ${
            tone === 'dark' ? 'text-background-100/80' : 'text-foreground-600'
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}